var map = {
  "./da.json": [
    "52036",
    [
      86757
    ]
  ],
  "./fi.json": [
    "30838",
    [
      96891
    ]
  ],
  "./sv.json": [
    "89254",
    [
      16459
    ]
  ],
  "./ja.json": [
    "55714",
    [
      49919
    ]
  ],
  "./lt.json": [
    "34339",
    [
      31872
    ]
  ],
  "./sl.json": [
    "23564",
    [
      40445
    ]
  ],
  "./fr.json": [
    "56175",
    [
      52260
    ]
  ],
  "./es.json": [
    "65491",
    [
      58192
    ]
  ],
  "./no.json": [
    "17536",
    [
      81273
    ]
  ],
  "./cs.json": [
    "28645",
    [
      75270
    ]
  ],
  "./en.json": [
    "14452",
    [
      26933
    ]
  ],
  "./description/en.json": [
    "25187",
    [
      31008
    ]
  ],
  "./pl.json": [
    "79127",
    [
      13820
    ]
  ],
  "./hu.json": [
    "25012",
    [
      61845
    ]
  ],
  "./nl.json": [
    "79293",
    [
      14926
    ]
  ],
  "./de.json": [
    "41864",
    [
      81617
    ]
  ],
  "./pt.json": [
    "62927",
    [
      17028
    ]
  ],
  "./it.json": [
    "21210",
    [
      99111
    ]
  ],
  "./et.json": [
    "29598",
    [
      76211
    ]
  ]
};
function __rspack_async_context(req) {
  if(!__webpack_require__.o(map, req)) {
    return Promise.resolve().then(() => {
var e = new Error("Cannot find module '" + req + "'");
e.code = 'MODULE_NOT_FOUND';
throw e;
});
  }

  var ids = map[req], id = ids[0];
  return __webpack_require__.e(ids[1][0]).then(() => (__webpack_require__.t(id, 3 | 16)));
}

__rspack_async_context.keys = () => (Object.keys(map));
__rspack_async_context.id = 28094;
module.exports = __rspack_async_context;
